"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseHash = void 0;
const parseHash = (hash) => {
    const strippedHash = hash.substring(1);
    return strippedHash.split('&').reduce((result, item) => {
        const [key, value] = item.split('=');
        result[key] = value;
        return result;
    }, {});
};
exports.parseHash = parseHash;
//# sourceMappingURL=parseHash.js.map